import React from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import { IMAGES } from "@/lib/images";

const Hero = () => {
  const { t } = useLanguage();

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen w-full overflow-hidden flex items-end"
    >
      {/* Background image */}
      <div
        className="absolute inset-0 ps-hero-bg"
        style={{
          backgroundImage: `url(${IMAGES.hero})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      {/* Dark veil */}
      <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0c] via-[#0a0a0c]/70 to-[#0a0a0c]/30" />
      <div className="absolute inset-0 grain" />

      {/* Top edge tags */}
      <div className="hidden md:flex absolute top-24 right-6 md:right-12 z-10 items-center gap-4 text-[10px] tracking-[0.32em] text-zinc-400 uppercase">
        <span className="w-6 h-[1px] bg-zinc-500/50" />
        <span>Ro · Riva del Po (FE)</span>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-6 md:px-12 pb-20 md:pb-28">
        <div className="max-w-4xl">
          <div className="flex items-center gap-4 mb-8">
            <span className="w-10 h-[1px] bg-[var(--ps-gold)]" />
            <span
              data-testid="hero-eyebrow"
              className="text-xs md:text-sm tracking-[0.32em] text-[var(--ps-gold)]"
            >
              {t.hero.eyebrow}
              <span className="ps-cursor" />
            </span>
          </div>

          <h1
            data-testid="hero-title"
            className="font-serif-display text-5xl sm:text-6xl md:text-7xl lg:text-[104px] leading-[0.95] tracking-tight text-white"
          >
            {t.hero.title.split(" ").map((w, i) => (
              <span
                key={i}
                className={`inline-block mr-[0.2em] ${
                  i % 2 === 1 ? "italic text-[var(--ps-gold)]" : ""
                }`}
              >
                {w}
              </span>
            ))}
          </h1>

          <p
            data-testid="hero-subtitle"
            className="mt-8 max-w-2xl text-base md:text-lg text-zinc-300 leading-relaxed"
          >
            {t.hero.subtitle}
          </p>

          <div className="mt-12 flex flex-col sm:flex-row gap-4">
            <button
              onClick={() => scrollTo("services")}
              data-testid="hero-cta-primary"
              className="ps-btn ps-btn-filled"
            >
              {t.hero.cta_primary}
            </button>
            <button
              onClick={() => scrollTo("contact")}
              data-testid="hero-cta-secondary"
              className="ps-btn"
            >
              {t.hero.cta_secondary}
            </button>
          </div>
        </div>
      </div>

      {/* Bottom scroll hint */}
      <div className="absolute bottom-6 right-6 md:right-12 z-10 flex items-center gap-3 text-[10px] tracking-[0.3em] text-zinc-400">
        <span>{t.hero.scroll}</span>
        <span className="w-[1px] h-10 bg-zinc-600 relative overflow-hidden">
          <span className="absolute inset-x-0 top-0 h-3 bg-[var(--ps-gold)] animate-[ps-zoom_2s_ease-in-out_infinite]" />
        </span>
      </div>
    </section>
  );
};

export default Hero;
